import { HeaderProvide } from "../headerProvide/HeaderProvider";

export default class HeaderProductCategories {
  static async AllHeaderProductCategories() {
    const res = await HeaderProvide.getHeaderProductCategories();
    return res;
  }
  static async AllHeaderServices() {
    const res = await HeaderProvide.getHeaderServices();
    return res;
  }
  static async getLanguegs() {
    const res = await HeaderProvide.getLanguages();
    return res;
  }

  static async getSearchProduct(searchKeyword: string) {
    const res = await HeaderProvide.getSearchProducts(searchKeyword);
    console.log(res,'search');
    
    return res;
  }

  static async getFilterItems(id: number) {
    const res = await HeaderProvide.getFilterItems(id);
    return res;
  }
  static async getFilterData(payload: any) {
    const res = await HeaderProvide.getFilterData(payload);
    return res;
  }
}
